import { createElement, type ComponentProps, type ReactElement } from "react";
import {
  KeyboardAvoidingView as KeyboardAvoidingViewFromReactNativeKeyboardController,
  KeyboardAwareScrollView as KeyboardAwareScrollViewFromReactNativeKeyboardController,
  KeyboardProvider as KeyboardProviderFromReactNativeKeyboardController,
  KeyboardStickyView as KeyboardStickyViewFromReactNativeKeyboardController,
} from "react-native-keyboard-controller";
import { withUniwind } from "@-/com.npmjs.uniwind";

type ReactNativeKeyboardProviderProps = ComponentProps<
  typeof KeyboardProviderFromReactNativeKeyboardController
>;

export type KeyboardProviderProps = Omit<ReactNativeKeyboardProviderProps, "preload">;

export function KeyboardProvider(props: KeyboardProviderProps): ReactElement {
  return createElement(KeyboardProviderFromReactNativeKeyboardController, {
    ...props,
    preload: false,
  });
}

// The keyboard-controller views are third-party NATIVE components, so they do not understand
// `className` on their own — `withUniwind` translates Tailwind classes into styles for them (the
// same treatment `components/ui/image` gives expo-image). Wrapping HERE rather than at each call
// site means every consumer gets it: there are ~15 usages across the app, and without this they
// fail to typecheck with `Type '{ className: string; … }' is not assignable` while the classes
// would also be silently dropped at runtime.
//
// Re-exported under the ORIGINAL names, so call sites keep importing `KeyboardStickyView` etc.
// from this package and need no change.
export const KeyboardStickyView = withUniwind(KeyboardStickyViewFromReactNativeKeyboardController);
export const KeyboardAvoidingView = withUniwind(
  KeyboardAvoidingViewFromReactNativeKeyboardController,
);
export const KeyboardAwareScrollView = withUniwind(
  KeyboardAwareScrollViewFromReactNativeKeyboardController,
);

export * from "react-native-keyboard-controller";
